export default __webpack_public_path__ + "static/media/video-poset-world@2x.d55077e8.png";